import { Component, Input, SimpleChanges, ViewChild } from '@angular/core';
import { ProjectViewModel } from '../../models-views/project.view.model';
import { ActivatedRoute, Router } from '@angular/router';
import { ClientViewModel } from '../../models-views/client.view.model';
import { TaskViewModel } from '../../models-views/task.view.model';
import { QuickAddService } from '../../services/quick-add.service';
import { Task } from '../../models/task.model';
import { NzTableComponent } from 'ng-zorro-antd/table';
import { takeUntil, skip, Subject, BehaviorSubject, throttleTime, fromEvent } from 'rxjs';
import { ConsoleViewModel } from '../../models-views/console.view.modal';
import { AppCommon } from '../../providers/app-common';
import { ProjectPlanService } from '../../services/project-plan.service';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { AddProjectPlanComponent } from '../add-project-plan/add-project-plan.component';
import { ConsoleTabService } from '../../services/console-tab.service';
import { Title } from '@angular/platform-browser';
import { TitleService } from '../../services/title.service';


@Component({
  selector: 'app-console-project-tab',
  standalone: false,
  templateUrl: './console-project-tab.component.html',
  styleUrl: './console-project-tab.component.scss'
})
export class ConsoleProjectTabComponent {
  @ViewChild('virtualTableTS', { static: false }) virtualTableTS?: NzTableComponent<Task>;
  private virtualScrollResizeObserver?: ResizeObserver;
  isVisible = false;
  @Input() tabData: any;
  projectData: any;
  regionData: any;
  clientData: any
  loading: boolean = true
  loadingMore: boolean = false
  listOfTasks: any = []
  listOfTaskStatus: any = []
  listOfPriority: any = []
  page: number = 1
  page_size: number = 6
  taskNext: any
  private destroy$ = new Subject<boolean>();
  showProjectPlanDrawer: boolean = false;
  showHistory: boolean;
  selectedType:any
  selectData:any
  showProjectDetail:boolean = false
  isConsolePage: boolean = false;
  projectDataModel = new BehaviorSubject<any>(undefined);
  selectedTabIndex:any = 0;
  projectFormatList: any[] = [];
  projectFormatTypeList: any[] = [];

  constructor(private vm: ProjectViewModel, private router: Router, private vmc: ClientViewModel,private titleService: TitleService,
    private quickAddService: QuickAddService, private vmt: TaskViewModel, private cvm: ConsoleViewModel,
    private projectPlanService: ProjectPlanService, private modalService: NzModalService,
    private activeRouter:ActivatedRoute,  private consoleTabService: ConsoleTabService
  ) {



    this.quickAddService.refreshData.pipe(takeUntil(this.destroy$)).subscribe(data => {
      if (data) {
         this.getData();
      }
    })

    this.vmt.taskStatusList.pipe(takeUntil(this.destroy$)).subscribe(data => {
      this.listOfTaskStatus = data.results
    })

    this.vmt.priorityList.pipe(takeUntil(this.destroy$)).subscribe(data => {
      this.listOfPriority = data.results
    })
    this.vmc.client.pipe(takeUntil(this.destroy$)).subscribe(data => {
      this.clientData = data
    })

    this.vm.projectFormatList.pipe(takeUntil(this.destroy$)).subscribe(data => {
      this.projectFormatList = data?.results || [];
      if (this.projectData?.project_format != null && this.projectFormatTypeList.length === 0) {
        this.loadProjectFormatTypeForProject();
      }
    })

    this.vm.projectFormatTypeList.pipe(takeUntil(this.destroy$)).subscribe(data => {
      this.projectFormatTypeList = data?.results || [];
    })

    this.cvm.ProjecttaskDataList.pipe(takeUntil(this.destroy$)).subscribe(data => {
     this.taskNext = data.next;
     // `previous == null` => fresh result set; otherwise append the next page, de-duped by id.
     if (data.previous == null) {
       this.listOfTasks = data.results;
       setTimeout(() => this.syncVirtualScrollViewportSize());
     } else {
       const seen = new Set(this.listOfTasks.map((t: any) => t.id));
       this.listOfTasks = [...this.listOfTasks, ...data.results.filter((t: any) => !seen.has(t.id))];
     }
     setTimeout(() => {
        this.loading = false
        this.loadingMore = false
       }, 100)
    });

    this.projectPlanService.planData$.pipe(takeUntil(this.destroy$)).subscribe(response => {
      if(response){
       this.projectPlanReceived(response);
      }
    })


  }

  // The virtual-scroll viewport measures its own size only once, on creation — often before layout
  // has settled, under-rendering rows until something (e.g. a window resize) forces a recheck.
  // A ResizeObserver self-heals regardless of exactly when the size settles.
  private syncVirtualScrollViewportSize(): void {
    this.virtualScrollResizeObserver?.disconnect();
    const viewport = this.virtualTableTS?.cdkVirtualScrollViewport;
    const el = viewport?.getElementRef().nativeElement;
    if (!viewport || !el || typeof ResizeObserver === 'undefined') {
      return;
    }
    this.virtualScrollResizeObserver = new ResizeObserver(() => viewport.checkViewportSize());
    this.virtualScrollResizeObserver.observe(el);
  }


  ngOnInit(): void {

    if (this.router.url.includes('/app/console')) {
      this.isConsolePage = true;
    } else {
      this.titleService.setTitle('Project Details');
    }

    if (this.router.url.includes('/app/projects')) {
      const pageID = Number(this.activeRouter.snapshot.paramMap.get('id'));
      this.tabData = {id: pageID, name: `project-details-${pageID}`}
    }
    sessionStorage.setItem('selectedProject', JSON.stringify(this.tabData.id));
    this.vmt.getTaskStatusList(this.page,this.page_size);
    this.vmt.getPriorityList(this.page,this.page_size);
    this.vm.parentConsoleProjectTabComponent = this;
    this.vm.projectData.pipe(takeUntil(this.destroy$)).subscribe(this.projectDataModel);
    this.vm.getProjectFormatList();
    this.getData();
  }

  getData() {
    this.loading = true;
    // Fresh load — send the task viewport back to the top before the request goes out.
    this.virtualTableTS?.cdkVirtualScrollViewport?.scrollToIndex(0);
    this.vm.getProjectById(this.tabData.id, 'app-console-project-tab');
  }

  getOtherData(){
    this.vmc.getClientByID(this.projectData?.project_client, 'app-console-project-tab');
    this.cvm.getTaskList(this.page,this.page_size,this.projectData,'project')
  }

   onLinksChanged(event: any){
    if(event == true){
      this.quickAddService.refreshData.next(true);
    }
  }

  createTask(type:any){
    this.quickAddService.openQuickAdd(type)
  }

  createEvent(type:any){
    this.quickAddService.openQuickAdd(type)
  }

  onFilesChanged(event: any){
    if(event == true){
      this.quickAddService.refreshData.next(true);
    }
  }

  onPocCreated(event:any){
    if(event == true){
      this.quickAddService.refreshData.next(true);
    }
  }

  dataReceived() {
    this.loading = false;
    this.projectData = this.projectDataModel.value;
    this.loadProjectFormatTypeForProject();

    this.regionData = this.getProjectRegion(this.projectData);

     if(this.isConsolePage){
      this.tabData.name = this.projectData.name;
    }
    this.getOtherData();
  }

  private loadProjectFormatTypeForProject(): void {
    const formatId = this.projectData?.project_format;
    if (formatId === null || formatId === undefined) {
      this.projectFormatTypeList = [];
      return;
    }

    const fmt = Array.isArray(this.projectFormatList)
      ? this.projectFormatList.find((f: any) => f?.id === formatId)
      : undefined;
    const name: string = (fmt?.name || '').toLowerCase();
    let isInPerson = name.includes('in') && name.includes('person');
    let isVirtual = name.includes('virtual');

    const opts: { is_inperson?: boolean; is_virtual?: boolean } = {};
    if (!fmt || (!isInPerson && !isVirtual)) {
      if (formatId === 1) {
        isInPerson = true;
      } else if (formatId === 2) {
        isVirtual = true;
      }
    }

    if (isInPerson) {
      opts.is_inperson = true;
    } else if (isVirtual) {
      opts.is_virtual = true;
    }

    this.vm.getProjectFormatTypeList(1, 500, opts);
  }

  getProjectTypeWithFormatLabel(): string {
    const typeId = this.projectData?.project_format_type;
    const formatId = this.projectData?.project_format;

    const typeName = this.projectFormatTypeList.find((t: any) => t?.id === typeId)?.name || '';
    const formatName = this.projectFormatList.find((f: any) => f?.id === formatId)?.name || '';

    if (typeName && formatName) {
      return `${typeName} (${formatName})`;
    }

    return typeName || formatName || '-';
  }

  private getProjectRegion(project: any): { region: string; region_ids: number[] } | null {
    const regionDetails = Array.isArray(project?.region_details)
      ? project.region_details
      : project?.region_details
      ? [project.region_details]
      : [];

    const regionNamesFromDetails = regionDetails
      .map((region: any) => region?.name)
      .filter((name: any) => !!name);

    const regionIdsFromDetails = regionDetails
      .map((region: any) => region?.id)
      .filter((id: any) => id !== null && id !== undefined);

    const fallbackRegionName =
      project?.region_name ||
      (typeof project?.region === 'string' ? project.region : '') ||
      project?.city_details?.region ||
      '';

    const fallbackRegionId =
      project?.region_id ||
      (typeof project?.region === 'number' ? project.region : null) ||
      project?.city_details?.region_id ||
      null;

    const regionName = regionNamesFromDetails.length > 0
      ? regionNamesFromDetails.join(', ')
      : fallbackRegionName;

    const regionIds = regionIdsFromDetails.length > 0
      ? regionIdsFromDetails
      : (fallbackRegionId !== null ? [fallbackRegionId] : []);

    return regionName ? { region: regionName, region_ids: regionIds } : null;
  }

   onTabChange(e: any) {
    // localStorage.setItem('selectedTab', JSON.stringify(e));
    this.selectedTabIndex = e;
  }


  projectDataReceivedError(){
    this.loading = false;

    if(!this.tabData.name.startsWith('client-details')){
      // this.router.navigate(['/app/clients'])
      this.modalService.confirm({
        nzTitle: 'The project is not available or deleted.',
        nzContent: '<b style="color: red;">Do you want to remove it?</b>',
        nzOkText: 'Yes',
        nzOkType: 'primary',
        nzOkDanger: true,
        nzOnOk: () => this.consoleTabService.removeConsoleTabById(this.tabData.id),
        nzCancelText: 'No',
        nzOnCancel: () => console.log('Cancel')
      });
    }
  }



  ngOnChanges(changes: SimpleChanges) {
    if (changes['tabData'].currentValue ) {
      // console.log('Input changed:', changes['tabData'].currentValue);
      // You can react to the new value here
      //this.projectData && this.vmc.getClientByID(this.projectData?.project_client, 'app-console-project-tab')
      //this.cvm.getTaskList(this.page,this.page_size,this.projectData,'project')
      // this.getOtherData();
    }
  }

  ngAfterViewInit(): void {
    this.virtualTableTS?.cdkVirtualScrollViewport?.scrolledIndexChange
      .pipe(takeUntil(this.destroy$), skip(1),throttleTime(300) )
      .subscribe((data: number) => {

        if (this.taskNext != null && !this.loadingMore) {
          this.loadingMore = true
          this.page++
          this.cvm.getTaskList(this.page, this.page_size, this.projectData, 'project')
          this.taskNext = null
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
    this.virtualScrollResizeObserver?.disconnect();
    Number(sessionStorage.getItem('selectedProject')) == this.tabData.id &&  sessionStorage.removeItem('selectedProject');
  }

  trackByIndex(_: number, data: Task): number {
    return data.id;
  }


  getPriorityColor(priority: string): string {
    switch (priority) {
      case 'High': return 'red';
      case 'Medium': return 'orange';
      case 'Low': return 'blue';
      default: return 'default';
    }
  }


  editProject(data: any) {
    this.quickAddService.openQuickUpdate('project', data)
  }

  deleteProject(data: any) {
    if(!data){
      return
    }
    // this.modalService.confirm({
    //   nzTitle: 'Are you sure delete "' + data.name + '"?',
    //   nzContent: '<b style="color: red;">If you delete this, you will no longer be able restore it.</b>',
    //   nzOkText: 'Yes',
    //   nzOkType: 'primary',
    //   nzOkDanger: true,
    //   nzOnOk: () => this.vm.deleteProjectById(data.id),
    //   nzCancelText: 'No',
    //   nzOnCancel: () => console.log('Cancel')
    // });
    this.vm.deleteProjectById(data.id)
  }

  projectDeleted(){
    if(this.tabData.name.startsWith('project-details')){
      this.router.navigate(['/app/projects'])
    } else {
      this.consoleTabService.removeConsoleTabById(this.tabData.id);
    }
  }


  getStatusColor(status: number): string {
    return status ? this.listOfTaskStatus.filter(e => e.id == status)[0].hexcolor : 'default';
  }


  getTaskPriorityName(id: number) {
    return id ? this.listOfPriority.filter(e => e.id == id)[0]?.name : ''
  }



  formatIdToFourDigits(id: number, str: string): string {
    return id ? str + id?.toString().padStart(4, '0') : '';
  }

  goToDetail(data: any) {
    // this.router.navigateByUrl('app/tasks')
    this.selectedType = 'task'
    this.selectData = data
    this.showProjectDetail = true;
    this.quickAddService.refreshData.next(true);
  }

  showModal(): void {
    this.isVisible = true;
  }

  handleOk(): void {
    this.isVisible = false;
  }

  handleCancel(): void {
    this.isVisible = false;
  }

  closeProjectDetail(){
    this.showProjectDetail = false;
    this.selectData = undefined;
    this.selectedType = undefined;
  }

  getIcon(name: string) {
    return name ? AppCommon.getDicebearIcon(name[0]) : '';
  }


  getBase64Image(data: any) {
    if (!data) {
      return undefined;
    }
    return "data:image/png;base64," + data;
  }


  openProjectPlan(project_plan_id: number) {
    this.loading = true;
    this.vm.getProjectPlan(project_plan_id);
  }


  projectPlanReceived(data: any) {
    this.showProjectPlanDrawer = true;
    this.loading = false;
  }

  closeProjectPlanDrawer() {
    this.showProjectPlanDrawer = false;
  }

  addProjectPlanModalRef?: NzModalRef;
  CreateProjectPlanModal(id: number, name: string): void {
    this.addProjectPlanModalRef = this.modalService.create({
      nzTitle: 'Add New Project Plan',
      nzContent: AddProjectPlanComponent,
      nzFooter: null,
      nzData: { id: id, name: name }
    });

    this.addProjectPlanModalRef.afterClose.subscribe(result => {
      if (result === true) {
        this.getData();
      }
    });
  }

  showHisory() {
    this.showHistory = true
  }

  setIsVisible() {
    this.showHistory = false
  }


  getAssignedToGroupInList(assigned_to_group_name: string): string[] {
    if (!assigned_to_group_name) {
      return [];
    }

    return assigned_to_group_name.includes(',')
      ? assigned_to_group_name.split(',').map(name => name.trim()).filter(name => name)
      : [assigned_to_group_name.trim()];
  }


}
